import { Component, OnInit, AfterViewInit, Input, ElementRef } from '@angular/core';
import * as moment from 'moment';
import * as jq from 'jquery';
import { OverlayPanel } from 'primeng/overlaypanel';
import { NotificationService } from 'projects/app-misc/src/app/modules/notification/data/notification.service';
import { Notification } from 'projects/app-misc/src/app/modules/notification/data/notification';
import { ProjectService } from '../../../../../data/project/project.service';
import { MatDialog } from '@angular/material/dialog';


@Component({
    selector: 'app-sub-history-notification',
    templateUrl: './sub-history-notification.component.html',
    styleUrls: ['./sub-history-notification.component.scss']
})
export class SubHistoryNotificationComponent implements OnInit, AfterViewInit {
    @Input()
    notification: Notification;

    @Input()
    history = false;

    @Input()
    notificationOP: OverlayPanel

    statusMessage: string;

    timeToShow: string;

    constructor(
        protected elementRef: ElementRef,
        protected dialog: MatDialog,
        protected projectService: ProjectService,
        protected notificationService: NotificationService
    ) {
    }

    ngOnInit() {
        const a = moment();
        const b = moment(this.notification.createdTime);

        if (a.diff(b, 'days') < 7) {
            this.timeToShow = moment(this.notification.createdTime).calendar();
        }

        else {
            this.timeToShow = moment(this.notification.createdTime).format('ll');
        }


        if (this.notification.message) {
            const str = this.notification.message;
            this.statusMessage = str
                .replace(/<(\w+)([^<]*)>/gim, '<span class=\"$1\"$2>')
                .replace(/<\/(\w+)>/gim, '</span>');
        }

    }

    ngAfterViewInit() {
        const el = this.elementRef.nativeElement as HTMLElement
        const nfEl = jq(el.getElementsByClassName('project'))
    }

}
